import React from "react";

import "./red-info-page.scss";

function HorseSVG() {
  return (
    <svg
      className="horse-man"
      data-name="svg2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1261.22 1148.16"
    >
      <g data-name="layer1">
        <path
          data-name="path3670"
          d="M734.18.4c-20.53-.17-54.92,6.93-54.92,6.93l-4.53,43H635.21c-2.72,3.42-23.73-2.9,2.27,15.84h41.78l6.79,11.31-11.71,17,9.44,5.6-4.52,11.31,6.79,2.27v9l9.05,4.52-11.32,11.32-31.68,52-20.36,43s-23.8,3.2-33.94,9.05-18.72,14.91-24.89,24.89c-5,8.12-9,27.16-9,27.16L443.93,378.42,462,412.36l400.51,40.73s24.82-22.8,20.8-36.09c-2.49-8.21-23.06-11.43-23.06-11.43H839.91s2.6-14.09,0-20.36c-3.67-8.87-20.36-20.37-20.36-20.37L837.65,349,858,299.22l-2.26-65.62-24.89-67.88L806,109.15,794.66,77.47V50.05l29.41-4.25,11.32-9.06-47.52-4.52-4.53-20.37S753.6,1.55,738.09.54c-1.23-.08-2.54-.13-3.91-.14ZM531.12,330.56l3.2,4.8-68.8,46.4-6.4-4.8ZM529.92,349,548,362.58l-24.89,22.63H477.87Z"
          transform="translate(0 0)"
          fill="black"
          stroke="black"
          stroke-miterlimit="3.2"
          stroke-width="0.8"
          fill-rule="evenodd"
        />
        <path
          data-name="path3668"
          d="M16.27,308.27C.65,328.38-.58,355.79.85,378l10.9-20v45.26L14,459.88,9.49,505.13l-9,31.68,11.31,43,29.41,29.42s11.09,12.51,18.11,11.31c4.76-.81,9-11.31,9-11.31s23.64-.57,29.41-9.05c5.54-8.13-2.26-29.42-2.26-29.42l52-83.72s18.5-11.1,22.63-20.37c1.23-2.75,0-9.05,0-9.05l13.58,6.79,47.51,70.15L278.75,616l18.1,52s-1.31,27,4.53,38.46c6.52,12.85,31.68,29.42,31.68,29.42v27.15l-6.79,88.25L315,880.75l-11.32,54.3-9.05,40.73L281,1034.61v18.1l-13.58,6.79L242.55,1107l38.47,6.79,40.72-2.26v-40.73l11.32-24.89,11.31-56.57,9.05-43,29.42-79.2,24.89-65.62L410,864.91l-6.79,65.62,4.53,29.41,6.79,27.15,33.94,27.16L482.4,1055l27.15,24.89h24.89l27.16,4.52,22.62,11.32,11.32-13.58,4.52-22.63-13.57-20.36-22.63-22.63-13.58,9H534.44l-58.83-49.78L464.3,959.94V926l24.89-43,22.62-97.3S644.28,803,708.67,790.24c33.13-6.56,92.78-40.73,92.78-40.73l22.62-11.32,13.58,11.32,18.1,70.14L867.07,883l9,47.52v36.2L846.7,998.41,815,1036.88l-52,58.83-38.47,18.1,4.53,18.1,20.36,15.84,58.83-4.53,9-9,6.79-24.89,52-70.14,43-45.26,38.46-33.94-11.31-63.36,11.31-58.83,29.42,52,40.73,43,33.94,56.57,27.15,83.72,8.67,14.19c-12.55,12.39-17.34,48.87-17.6,57.17l45.14,3.31,29.41-11.31,1-15.71-16.89-20.5-27.15-110.87-11.31-58.83-6.79-29.42-61.09-81.46,38.46-95S1093,682.13,1093.34,659c.38-27.67-24.89-79.2-24.89-79.2s1.66-7.28,4.52-9c3.85-2.38,13.58,0,13.58,0s26.9,27.76,33.94,45.25c16.18,40.18,15.84,129,15.84,129l4.53-27.15,11.31,54.3,9-56.56,13.58,67.88,4.52-45.26L1190.64,831s2.2,83.42,9,124.45c6.81,40.78,31.68,119.92,31.68,119.92l-9-72.41,22.62,72.41c-8-43.81-4.57-80,0-115.4l13.58-97.3-2.26-101.82,4.52,24.89s.73-45.82-4.52-67.88c-12.54-52.6-63.36-149.34-63.36-149.34s-30.77-36.54-52-45.26c-22.38-9.17-72.41-4.52-72.41-4.52L1036.77,521,962.1,491.55l-79.2-31.67L536.7,392H482.4L342.11,330.9l18.1-2.26c-16.27-9.36-33-17.87-55.52-14.65l21.58-5.72c-21.12-12-42.24-14.18-63.36-11.31l38.47-4.53-58.83-9.05,20.36-6.79c-29.46-5.77-59-11.27-90.51-4.52l27.16-15.84c-28.66,5.18-57.33,7.4-86,22.63L79.63,308.27s-6.95-30.91-18.1-40.73c-5.91-5.2-22.63-6.79-22.63-6.79v18.11l-20.36-6.79H5L20.8,299.22Z"
          transform="translate(0 0)"
          fill="black"
          stroke="black"
          stroke-miterlimit="3.2"
          stroke-width="0.8"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
}

const RedInfoPage = () => {
  return (
    <div className="info-page" id="infoPage">
      <div className="info-page-background">
        <div className="info-content">
          <div className="info-text-box">
            <div className="info-title">Üdvözlünk Kalandor</div>
            <ul className="info-description">
<li>
  Üdvözlünk az American Wildwest világában!  
  Közösségünk célja, hogy egy hiteles, izgalmas és folyamatosan fejlődő
  vadnyugati szerepjáték élményt nyújtson minden kalandornak.{" "}
  <br />
  Lépj vissza az 1850-es évek Amerikájába, ahol a törvény gyakran csak
  papíron létezett, a határvidék pedig tele volt lehetőséggel,
  veszéllyel és megíratlan történetekkel. Itt nemcsak egy karaktert
  irányítasz, hanem egy egész életet alakíthatsz ki a vad határvidék
  árnyékában.
</li>

<li>
  Válassz a számtalan életút közül: válhatsz vadásszá, prémkereskedővé,
  rancheré, seriffé, orvossá, banditává vagy akár egy teljesen egyedi
  hivatást is megalkothatsz. A világ reakciói, a közösségi események és
  a szerepjátékos döntések alakítják a történelmet, amelynek te is
  aktív részese lehetsz.  
  Fedezd fel a hatalmas területeket, ismerj meg más karaktereket,
  köss szövetségeket vagy teremts ellenségeket, minden rajtad múlik.
</li>

<li>
  Készen állsz saját legendád megírására?  
  Csatlakozz, és válj a vadnyugat történelmének egyik szereplőjévé.
  A világ nyitva áll előtted csak be kell lépned.
</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedInfoPage;
